/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Course,
    CourseFromJSON,
    CourseFromJSONTyped,
    CourseToJSON,
    Office,
    OfficeFromJSON,
    OfficeFromJSONTyped,
    OfficeToJSON,
    Teacher,
    TeacherFromJSON,
    TeacherFromJSONTyped,
    TeacherToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeacherResponse
 */
export interface TeacherResponse {
    /**
     * 
     * @type {Teacher}
     * @memberof TeacherResponse
     */
    teacher: Teacher;
    /**
     * 
     * @type {Office}
     * @memberof TeacherResponse
     */
    office?: Office;
    /**
     * 
     * @type {Course}
     * @memberof TeacherResponse
     */
    course?: Course;
}

export function TeacherResponseFromJSON(json: any): TeacherResponse {
    return TeacherResponseFromJSONTyped(json, false);
}

export function TeacherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teacher': TeacherFromJSON(json['teacher']),
        'office': !exists(json, 'office') ? undefined : OfficeFromJSON(json['office']),
        'course': !exists(json, 'course') ? undefined : CourseFromJSON(json['course']),
    };
}

export function TeacherResponseToJSON(value?: TeacherResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teacher': TeacherToJSON(value.teacher),
        'office': OfficeToJSON(value.office),
        'course': CourseToJSON(value.course),
    };
}


